// src/modules/app-views/account/pages/Init/SubscriptionsTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import { Col, Row, Tooltip } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { useNavigate } from 'react-router-dom';
import translateX from 'utils/translateX';
import useZustand from 'hooks/useZustand';
import { useDocumentContext } from 'components/core/DocumentProvider';
import useApi from 'hooks/useApi';
import TileItem, { AddTileItem } from 'layouts/SharedComponents/TileItem';
import app from 'configs/appResolver';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AccountsSubscriptionsTab = ({ tabName }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const setPageStore = useZustand('module', 'setPage');
  const storedUser = useZustand('auth', 'user');
  const setLoadingPageStore = useZustand('boot', 'setLoadingPage');
  const { tab: selectedTab } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const navigate = useNavigate();
  useApi({
    hideLoading: selectedTab === tabName,
    paramKey: null,
    selectedTab: tabName,
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleNewSubscription = () => {
    if (!storedUser?._id) return;

    // Show loading and wait for React to paint before navigating
    setLoadingPageStore({ visible: true });

    // Double requestAnimationFrame ensures browser paints loading before navigation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setPageStore({
          navigate,
          pageName: 'subscription',
          params: {
            userId: storedUser._id,
            subscriptionId: 'add',
          },
        });
      });
    });
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      {/*<SimpleLoadingArea name="subscriptionsTab" isFetching={loading} data={subscriptions} />*/}

      <div className="container-fluid no-item-hover">
        <Row gutter={ROW_GUTTER}>
          {storedUser?.subscriptions?.map(record => (
            <Col xs={24} md={12} xl={8} key={record._id}>
              <TileItem record={record} hoverable strongBorder showAvatar />
            </Col>
          ))}

          {app.PRESET?.MULTI_SUBSCRIPTIONS !== false && (
            <Col xs={24} md={12} xl={8} key="__add__">
              <Tooltip placement="top" title={translateX('new_organization')}>
                <div>
                  <AddTileItem onClick={handleNewSubscription} />
                </div>
              </Tooltip>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AccountsSubscriptionsTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
